
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { ALTS_COLORS } from "@/utils/colors";

interface AllocationModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  allData: { name: string; value: number }[];
  editableAllocations: Record<string, number>;
  onAllocationChange: (name: string, value: number) => void;
  onSave: () => void;
}

export const AllocationModal = ({
  isOpen,
  onOpenChange,
  allData,
  editableAllocations,
  onAllocationChange,
  onSave,
}: AllocationModalProps) => {
  const colors = [
    ALTS_COLORS.spaceCadet,
    ALTS_COLORS.yaleBlue,
    ALTS_COLORS.yinMnBlue,
    ALTS_COLORS.paynesGray,
    ALTS_COLORS.battleshipGray,
    ALTS_COLORS.lion,
    ALTS_COLORS.satinSheenGold,
    ALTS_COLORS.goldenrod
  ];

  const totalAllocation = Object.values(editableAllocations).reduce((a, b) => a + b, 0);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Adjust Alternative Allocations</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          {allData.map((item, index) => (
            <div key={item.name} className="grid grid-cols-2 items-center gap-4">
              <div className="flex items-center gap-2">
                <div 
                  className="w-3 h-3 rounded-sm" 
                  style={{ backgroundColor: colors[index] }} 
                />
                <span className="text-sm font-medium">{item.name}</span>
              </div>
              <div className="relative">
                <Input
                  type="number"
                  value={editableAllocations[item.name] || 0}
                  onChange={(e) => onAllocationChange(item.name, parseFloat(e.target.value) || 0)}
                  className="pr-8"
                  min="0"
                  max="100"
                />
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-500">
                  %
                </span>
              </div>
            </div>
          ))}
          <div className="flex justify-between items-center pt-2">
            <span className="text-sm font-medium">
              Total: <span className={totalAllocation === 100 ? "text-green-600" : "text-amber-600"}>
                {totalAllocation}%
              </span>
            </span>
            <Button 
              onClick={onSave}
              disabled={totalAllocation !== 100}
            >
              Save Changes
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
